const features = [
  {
    title: '高清画质',
    desc: '720P / 1080P 高清片源，部分支持 4K，画质清晰细腻不模糊',
    icon: 'ri-4k-line',
  },
  {
    title: '流畅不卡顿',
    desc: '智能 CDN 加速和自适应码率技术，网络波动也能畅快播放',
    icon: 'ri-speed-up-line',
  },
  {
    title: '完全免费',
    desc: '无需注册无需付费，所有影视资源永久免费在线观看',
    icon: 'ri-vip-crown-line',
  },
  {
    title: '每日更新',
    desc: '每日同步上线 50+ 新片，热播剧集与电视台同步更新',
    icon: 'ri-refresh-line',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">平台优势</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">为什么超过百万影迷选择小辣椒影院</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature) => (
            <div key={feature.title} className="bg-background-100 border border-background-200/70 rounded-lg p-6 text-center group hover:border-accent-300 transition-colors">
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 mx-auto mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}